import React from "react";
import "./deletaccount.scss";
import { logicalIcon } from "../../assets";

const DeleteAccount = () => {
  return (
    <div className="wrapper_delete_account">
      <section className="wrap_delete_account">
        <div className="custom_container">
          <div className="logo_delete">
            <img className="" src={logicalIcon} alt="Logo" />
            <h2>Delete my Account</h2>
          </div>
        </div>
      </section>

      <section className="wrap_delete_account_content">
        <div className="custom_container">
          <div className="how_to_delete_accnt">
            <h6>How do I delete my account?</h6>
            <p>Via your Logical Chat</p>

            <ol>
              <li> Go to your profile tab (bottom right tab on the app)</li>
              <li>Scroll down to the "My Account" link. Tap on it</li>
              <li>
                Scroll down to the "Delete My Logical Chat" link and tap on it.
              </li>
            </ol>

            <h6>Via Email</h6>
            <p>
              Simply reach out to us over email at hello@Logicalchat.app from
              the email address associated with your Logical Chat account
            </p>
          </div>

          <div className="what_happen_delete_accnt">
            <h6>What happens to my data once my account has been deleted?</h6>
            <p>
              Please note, once you have deleted your account, you will not be
              able to recover your data. The process is irreversible.
            </p>

            <p>
              ​We will no longer have any of your personal data on our systems.
              However all anonymised (not linked to you, your name, or your
              email address) aggregate data will remain.
            </p>

            <p>
              <b>IMPORTANT:</b> If you have an active subscription via the
              Google Play Store or the Apple App Store, make sure you cancel
              your subscription via the subscription management page of your
              Play Store or App Store account. ​As of October 2025, the
              instructions on how to manage/cancel your app subscriptions can be
              found here:
            </p>
          </div>

          <div className="ask_anythings">
            <div className="ask_wrap_inner">
              <h3>Ask Us Anything</h3>

              <h4>
                For any inquiry and program related queries, get in touch at:
              </h4>
              <p>hello@Logicalchat.app</p>

              <h4>For business related queries, get in touch at:</h4>
              <p>Logicalchat</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DeleteAccount;
